import axios from "axios";

const publicAxios = axios.create({
  baseURL: 'https://xplor.alfaridah.ae/api/items/'
});

export {
  publicAxios
};